<template>
    <ul class="d-flex flex-column px-0">
        <div class="spinner-overlay" v-if="showSpinner"></div>
        <div class="w-100 d-flex justify-content-center">
            <b-spinner class="mx-auto my-3" v-if="showSpinner"></b-spinner>
        </div>
        <li class="d-flex flex-column" v-for="(data, index) in events" :key="index">
            <div class="d-flex">
                <div
                    class="wrap-date-title d-flex my-3"
                >{{format(parseISO(data.event.start_datetime + "Z"), dateFormat)}}</div>
            </div>
            <div class="d-flex">
                <div
                    class="info-meetup d-flex flex-column flex-md-row w-100"
                    :class="{waiting: data.waiting}"
                >
                    <div class="d-flex flex-column flex-md-row pl-md-2">
                        <a
                            target="_blank"
                            class="img-wrap mb-3 mb-md-0 mr-md-3"
                            :href="getUrl(data.event.type, data.event.slug, data.event.relativeUrl, data.event.start_datetime)"
                        >
                            <img
                                class="img-events"
                                :src="data.event.banner_url || '/img/event-banner-default.jpg'"
                            />
                            <div class="waiting-tag px-2 py-1">WAITING LIST</div>
                        </a>
                        <div class="desc-events">
                            <div
                                v-if="data.event.type === 'conference'"
                                class="wrap-icon-events d-flex align-items-center"
                            >
                                <i class="material-icons">record_voice_over</i>
                                <div>Conference</div>
                            </div>
                            <div
                                v-if="data.event.type === 'online_conference'"
                                class="wrap-icon-events d-flex align-items-center"
                            >
                                <i class="material-icons">ondemand_video</i>
                                <div>Online Conference</div>
                            </div>
                            <div
                                v-if="data.event.type === 'meetup'"
                                class="wrap-icon-events d-flex align-items-center"
                            >
                                <i class="material-icons">group</i>
                                <div>Meetup</div>
                            </div>
                            <div
                                v-if="data.event.type === 'webinar'"
                                class="wrap-icon-events d-flex align-items-center"
                            >
                                <i class="material-icons">voice_chat</i>
                                <div>Webinar</div>
                            </div>
                            <a
                                target="_blank"
                                :href="getUrl(data.event.type, data.event.slug, data.event.relativeU_url || data.event.relativeUrl, data.event.start_datetime)"
                            >
                                <div class="title-events">{{data.event.name}}</div>
                            </a>
                            <div
                                clas="date"
                            >{{format(parseISO(data.event.start_datetime + "Z"), dateFormat+" h:mm a")}}</div>
                            <div class="location">{{data.event.location_name}}</div>
                            <button
                                v-if="data.event_type==='conference'"
                                class="btn btn-outline-success btn-sm mt-2"
                                data-toggle="modal"
                                data-target="#modal-ticket"
                            >Show ticket</button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="data.event_type==='conference'"
                class="modal fade"
                id="modal-ticket"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLongTitle">My ticket</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i class="material-icons">clear</i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div
                                class="d-flex justify-content-center align-items-center flex-column wrap-info-ticket"
                            >
                                <div>Here is your ticket for</div>
                                <div>
                                    Conference -
                                    <span>{{data.event.location_city}}</span>
                                </div>
                            </div>
                            <div
                                class="date d-flex justify-content-center align-items-center flex-column px-3 py-3"
                            >
                                <div>{{format(parseISO(data.event.start_datetime + "Z"), "iii, MMM do, yyyy, h:mm a")}}</div>
                                <div>{{format(parseISO(data.event.end_datetime + "Z"), "iii, MMM do, yyyy, h:mm a")}}</div>
                            </div>
                            <div
                                class="info-location d-flex justify-content-center align-items-center flex-column px-3 py-3"
                            >
                                <div>{{data.event.location_name}}</div>
                                <div
                                    v-if="data.event.type !== 'online_conference'"
                                >{{data.event.location_address}}</div>
                            </div>
                            <hr />
                            <div
                                class="qrcode d-flex justify-content-center align-items-center flex-column px-3 pb-4"
                            >
                                <div class="txt-qrcode">Use the QR code below to access the event.</div>
                                <qrcode :value="data.ticketid" :options="{ width: 150 }"></qrcode>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import { format, parseISO } from "date-fns";
export default {
    name: "eventsCard",
    props: ["events", "showSpinner"],
    methods: {
        format,
        parseISO,
        getUrl(type, slug, path, date) {
            switch (type) {
                case "webinar":
                    return "//events.codemotion.com/webinars/" + slug;
                case "conference":
                    return "//events.codemotion.com" + path;
                case "meetup":
                    return "//community.codemotion.com" + path;
                case "online_conference":
                    return `//events.codemotion.com/conferences/online/${date.substring(
                        0,
                        4
                    )}/${slug}`;
            }
        },
    },
    data: () => ({
        dateFormat: "iiii, MMMM do, yyyy",
    }),
};
</script>


<style lang="scss">
@import "@/assets/scss/_common.scss";
a {
    color: $palette-blue !important;
    &:hover {
        color: $palette-orange !important;
    }
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
.spinner-overlay {
    width: 100%;
    height: calc(100% - 80px);
    position: absolute;
    top: 102px;
    left: 0;
    z-index: 5;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.spinner-border {
    z-index: 6;
}
.wrap-date-title {
    margin-bottom: 5px;
    &::before {
        content: "";
        background-color: #b3b3b3;
        width: 8px;
        height: 8px;
        border-radius: 1em;
        text-align: center;
        font-size: 0.3em;
        position: relative;
        top: 8px;
        left: 0;
        margin-right: 10px;
        display: none;
        @media all and (min-width: $size-large-portrait) {
            display: block;
        }
    }
}

.info-meetup {
    &::before {
        content: "";
        background-color: #e5e5e5;
        max-width: 4px;
        height: 100%;
        border-radius: 1em;
        text-align: center;
        font-size: 0.3em;
        position: relative;
        left: 2px;
        display: none;
        width: 1%;
        @media all and (min-width: $size-large-portrait) {
            display: block;
        }
    }
    .waiting-tag {
        display: none;
    }
    &.waiting {
        opacity: 0.4;
        .img-wrap {
            position: relative;
        }
        .waiting-tag {
            display: block;
            position: absolute;
            top: 5px;
            right: 5px;
            border-radius: 5px;
            background: white;
            color: $palette-blue;
        }
    }

    .img-events {
        height: 124px;
        width: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        border-radius: 5px;
        background: white;
        @media all and (min-width: $size-large-portrait) {
            width: 220px;
        }
    }

    .desc-events {
        .wrap-icon-events {
            text-transform: uppercase;
            color: $palette-light-blue;
            font-weight: 600;
            font-size: 14px;
            i {
                font-size: 22px;
                margin-right: 5px;
            }
        }
        a {
            color: $palette-blue !important;
            &:hover {
                color: $palette-orange !important;
            }
        }
    }

    .title-events {
        font-weight: 600;
    }

    .date {
        font-size: 14px;
    }
    .location {
        font-size: 14px;
        color: #777777;
    }
}

.modal-content {
    &::before {
        content: "";
        background: #808080;
        width: 22px;
        height: 12.1px;
        position: absolute;
        left: calc(50% - 11px);
        z-index: 5;
        top: 0;
        border-radius: 0 0 100px 100px;
    }
    &::after {
        content: "";
        background: #808080;
        width: 22px;
        height: 12.1px;
        position: absolute;
        left: calc(50% - 11px);
        z-index: 5;
        bottom: 0;
        border-radius: 100px 100px 0px 0px;
    }
}

.modal-body {
    padding: 0;
    .wrap-info-ticket {
        background-color: $palette-orange;
        color: $palette-blue;
        padding: 1rem;
        font-size: 20px;
        font-weight: 600;
    }
    .info-location {
        color: #777777;
    }

    .txt-qrcode {
        color: #777777;
        font-size: 11px;
    }

    hr {
        margin-top: 1rem;
        margin-bottom: 1rem;
        border: 0;
        border-top: 1px dashed rgba(0, 0, 0, 0.2);
    }
}

li {
    padding: 15px 0;
    border-bottom: 1px solid #dcdcdc;
    @media all and (min-width: $size-large-portrait) {
        padding-bottom: 0px;
        border-bottom: 0px solid #dcdcdc;
        padding-top: 5px;
    }
}
</style>